var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVerticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 129,
    viewBox: "0 0 258 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.421 128.894H242.39L248.81 113.768H250.979L257.431 128.894H255.263L253.306 124.134H248.303L248.842 122.547H252.65L249.826 115.693L244.421 128.894Z",
    fill: "#DAAF51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.518 128.894H222.487L228.908 113.768H231.076L237.529 128.894H235.36L233.403 124.134H228.4L228.94 122.547H232.748L229.923 115.693L224.518 128.894Z",
    fill: "#DAAF51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.764 113.768V128.894H213.808V113.768H215.764Z",
    fill: "#DAAF51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.487 128.894V113.768H194.444L203.7 125.953V113.768H205.551V128.894H203.594L194.338 116.602V128.894H192.487Z",
    fill: "#DAAF51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.034 113.768V115.354H177.1V120.431H184.663V122.018H177.1V127.307H185.192V128.894H175.144V113.768H185.034Z",
    fill: "#DAAF51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.318 121.331L154.363 113.768H156.743L161.503 119.818L166.263 113.768H168.643L162.698 121.331L168.643 128.894H166.263L161.503 122.843L156.743 128.894H154.363L160.318 121.331Z",
    fill: "#DAAF51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.272 128.894V113.768H127.229L136.485 125.953V113.768H138.336V128.894H136.379L127.124 116.602V128.894H125.272Z",
    fill: "#DAAF51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.852 121.289C104.852 125.371 106.696 127.413 110.384 127.413C113.994 127.413 115.799 125.371 115.799 121.289C115.799 117.262 113.994 115.249 110.384 115.249C106.696 115.249 104.852 117.262 104.852 121.289ZM102.789 121.352C102.789 116.225 105.321 113.662 110.384 113.662C115.369 113.662 117.862 116.225 117.862 121.352C117.862 126.45 115.369 129 110.384 129C105.321 129 102.789 126.45 102.789 121.352Z",
    fill: "#DAAF51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0613 113.768V128.894H93.1045V113.768H95.0613Z",
    fill: "#DAAF51"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9961 128.894V113.768H73.9529V120.431H82.891V113.768H84.8479V128.894H82.891V122.018H73.9529V128.894H71.9961Z",
    fill: "#DAAF51"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4259 128.365C63.1214 128.788 61.711 129 60.1949 129C54.9061 129 52.2617 126.373 52.2617 121.119C52.2617 116.148 54.9061 113.662 60.1949 113.662C61.711 113.662 63.1214 113.874 64.4259 114.297V115.989C63.1214 115.496 61.7815 115.249 60.4065 115.249C56.2812 115.249 54.2186 117.206 54.2186 121.119C54.2186 125.315 56.2812 127.413 60.4065 127.413C61.7815 127.413 63.1214 127.166 64.4259 126.673V128.365Z",
    fill: "#DAAF51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4207 113.768V127.307H46.3328V128.894H36.4639V113.768H38.4207Z",
    fill: "#DAAF51"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0582 128.894H15.0273L21.4479 113.768H23.6163L30.0687 128.894H27.9003L25.9434 124.134H20.9402L21.4797 122.547H25.2876L22.4634 115.693L17.0582 128.894Z",
    fill: "#DAAF51"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89004 113.768V115.354H1.95685V120.431H9.51983V122.018H1.95685V128.894H0V113.768H9.89004Z",
    fill: "#DAAF51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0283 0C66.9038 22.7797 118.368 27.661 110.784 59.3898C96.1571 34.1695 53.9025 26.8475 62.0283 0Z",
    fill: "#DAAF51"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8835 29.2881C70.6961 35.6158 78.4428 49.5186 102.929 54.5085C99.9495 43.661 75.5717 33.8983 69.8835 29.2881Z",
    fill: "#DAAF51"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0095 46.6441C78.0553 46.7863 78.1057 46.9323 78.1607 47.0819C80.7968 52.7489 108.651 55.564 109.972 65.0847C89.2745 63.8161 80.2758 52.8273 78.1607 47.0819C78.0937 46.9378 78.043 46.7919 78.0095 46.6441Z",
    fill: "#DAAF51"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.972 0.271186C190.096 23.0508 138.632 27.9322 146.216 59.661C160.843 34.4407 203.098 27.1186 194.972 0.271186Z",
    fill: "#DAAF51"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.658 29.2881C186.846 35.6158 179.099 49.5186 154.613 54.5085C157.592 43.661 181.97 33.8983 187.658 29.2881Z",
    fill: "#DAAF51"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.532 46.6441C179.487 46.7863 179.436 46.9323 179.381 47.0819C176.745 52.7489 148.891 55.564 147.57 65.0847C168.267 63.8161 177.266 52.8273 179.381 47.0819C179.448 46.9378 179.499 46.7919 179.532 46.6441Z",
    fill: "#DAAF51"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.993 72.678V52.6102L128.716 66.7119L137.058 53.9661V73.7627L152.226 84.0678L144.913 91.3898L134.078 78.3729L139.767 93.2881L130.828 96L127.849 79.4576L126.223 96L117.827 93.2881L122.431 78.3729L112.138 91.3898L104.825 83.2542L119.993 72.678Z",
    fill: "#DAAF51"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.59 35.7966C120.59 40.2898 124.228 43.9322 128.716 43.9322C133.204 43.9322 136.842 40.2898 136.842 35.7966H142.311L128.471 59.7966L114.631 35.7966H120.59Z",
    fill: "#DAAF51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerticle);
export default __webpack_public_path__ + "static/media/logo-verticle.e3109de0d9c34ccb554f17fea985cba5.svg";
export { ForwardRef as ReactComponent };